<div class="file-card-container {{file.type}}" [ngClass]="{'mobile': device.isMobile, 'desktop': device.isDesktop, 'selected': fileSelected }">
    <div class="file-card-content {{file.type}}" [ngClass]="{'desktop': !device.isMobile, 'mobile': device.isMobile, 'no-preview': !previewable }" 
    (click)="handleContentClick(file, $event)">
        <!-- Image -->
        <ng-container *ngIf="previewable && file.type === 'image'">
            <app-smash-image  
                [ngClass]="{'thumbnail': !device.isMobile }" 
                [url]="file.thumbnail"
                (imageLoadError)="handleImageError()"
                maxRetry="2"
                type="thumbnail"
                [device]="device"></app-smash-image>
        </ng-container>

        <!-- Player Audio -->
        <ng-container *ngIf="device.isDesktop && previewable && file.type === 'audio'" >
            <div class="placeholder-icon">
                <i class="icon-smash_audio"></i>                         
            </div>  
            <div class="placeholder-file-extension" *ngIf="device.isDesktop">
                <app-file-extension [fileType]="file.type" [fileExtension]="file.ext" [device]="device"></app-file-extension>                         
            </div>
            <div class="placeholder-audio-player" *ngIf="device.isDesktop">
                <app-smash-player #player *ngIf="playerDisplayed" 
                    [source]="playerSource"
                    [options]="playerOptions" 
                    [ngClass]="{'desktop': device.isDesktop }"
                    class="smash-sound-player">
                </app-smash-player>
            </div>
        </ng-container>

        <!-- Player Video -->
        <ng-container *ngIf="previewable && file.type === 'video'">
            <div *ngIf="device.isDesktop" class="placeholder-icon"  [ngClass]="{'mobile': device.isMobile }">
                <i class="icon-smash_video"></i>
            </div>
            <div *ngIf="device.isDesktop" class="placeholder-file-extension" >
                <app-file-extension [fileType]="file.type" [fileExtension]="file.ext" [device]="device"></app-file-extension>                         
            </div>
            <div class="player-video-container" *ngIf="playerDisplayed" [ngClass]="{'mobile': device.isMobile }">
                <div class="close-video-container" (click)="killPlayer($event)"><i class="icon-smash_close"></i></div>
                <app-smash-player #player
                    [source]="playerSource"
                    [options]="playerOptions"
                    (readyToPlay)="togglePlay($event)"
                    (plyrExitFullScreen)="killPlayer($event)"
                    class="smash-video-player">
                </app-smash-player>
            </div>
        </ng-container>

        <!-- Unknown File Type -->
        <ng-container *ngIf="!previewable && !device.isMobile">
            <app-file-extension [fileType]="file.type" [fileExtension]="file.ext" [device]="device"></app-file-extension>
        </ng-container>
    </div>

    <div class='file-card-footer {{file.type}}' [ngClass]="{'selected': fileSelected, 'mobile': device.isMobile, 'desktop': device.isDesktop, 'with-preview': previewable && file.type === 'image'}">                
        <div class="file-informations">
            <app-file-extension *ngIf="device.isMobile" [fileType]="file.type" [fileExtension]="file.ext" [device]="device"></app-file-extension>
            <div class="file-metas" [ngClass]="{'mobile': device.isMobile}">
                <div class="file-name">{{file.name}}</div>
                <div class="file-size">{{file.size | bytes: 2}} {{ file.ext }}</div>
                <div class="file-informations-full" *ngIf="device.isDesktop">
                    <div class="file-name">{{file.name}}</div>
                </div>                
                <!-- mobile audio player -->
                <div *ngIf="device.isMobile && previewable && file.type === 'audio'" class="player-wrapper mobile">
                    <div class="player-audio-container mobile" [ngClass]="{'animate': playerDisplayed }">
                        <app-smash-player #player *ngIf="playerDisplayed" 
                            [source]="playerSource"
                            [options]="playerOptions" 
                            [ngClass]="{'desktop': device.isDesktop }"
                            class="smash-sound-player">
                        </app-smash-player>
                    </div>
                </div>  
            </div>            
        </div>
        <div class="file-action">
            <ng-container *ngIf="device.isDesktop; else mobileView">
                <app-smash-checkbox class="checkbox" [(ngModel)]="fileSelected"
                    (valueChange)="handleFileSelection($event)"></app-smash-checkbox>
            </ng-container>
            <ng-template #mobileView>
                <!-- mobile video player ? -->
                <div *ngIf="previewable && file.type === 'video'" class="player-toggle" [ngClass]="{'mobile': device.isMobile}">
                    <div class="btn-audio-toggle" (click)="setupPlayer(file)"><i class="icon-smash_play"></i></div>
                </div>
                <!-- mobile audio player -->
                <div *ngIf="previewable && file.type === 'audio'" class="player-toggle" [ngClass]="{'mobile': device.isMobile}">
                    <ng-container *ngIf="device.isMobile ">
                        <ng-container *ngIf="!playerDisplayed; else playerClose">
                            <div class="btn-audio-toggle" (click)="togglePlay($event, file)"><i class="icon-smash_play"></i></div>
                        </ng-container>
                        <ng-template #playerClose>
                            <div class="btn-audio-toggle" (click)="killPlayer($event)"><i class="icon-smash_close"></i></div>
                        </ng-template>
                    </ng-container>
                </div>  
                <div class="icon-download" (click)="$event.stopPropagation()">
                    <a [href]="file.download" target="_blank" (click)="$event.stopPropagation()">
                        <i class="icon-smash_download"></i>
                    </a>
                </div>
            </ng-template>
        </div>
    </div>
</div>